import L from "leaflet";
import { Marker } from "react-leaflet";
import markerEventIcon from "./MarkerEventIcon";

const MapStatusMarker = (props) => {
  const { position, status } = props;

  const svgIcon = L.divIcon({
    html: `${markerEventIcon.getMarker(status)}`,
    className: "svg-icon",
    iconSize: [20, 20],
    popupAnchor: [0, -20],
  });

  return (
    <Marker position={position} icon={svgIcon} status={status}>
      {props.children}
    </Marker>
  );
};

export default MapStatusMarker;
